import { render, staticRenderFns } from "./ArceProfileClient.vue?vue&type=template&id=400086b0&"
import script from "./ArceProfileClient.vue?vue&type=script&lang=js&"
export * from "./ArceProfileClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports